import CountryList from '../../slices/master/country/CountryList'
import CountryDetails from "../../slices/master/country/CountryDetails"
import StateList from '../../slices/master/state/StateList'
import StateDetails from '../../slices/master/state/StateDetails'
import StatebyCountry from '../../slices/master/state/StatebyCountry'
import DistrictList from '../../slices/master/district/DistrictList'
import DistrictDetails from '../../slices/master/district/DistrictDetails'
import DistrictbyState from '../../slices/master/district/DistrictbyState'
import TehsilList from '../../slices/master/tehsil/TehsilList'
import TehsilDetails from '../../slices/master/tehsil/TehsilDetails'
import TehsilbyDistrict from '../../slices/master/tehsil/TehsilbyDistrict'
import NatureList from '../../slices/master/nature/NatureList'
import NatureDetails from '../../slices/master/nature/NatureDetails'
import StructureList from '../../slices/master/structure/StructureList'
import StructureDetails from '../../slices/master/structure/StructureDetails'
import CropList from '../../slices/master/crop/CropList'
import CropDetails from '../../slices/master/crop/CropDetails'
import BioMasterList from '../../slices/master/bio_master/BioMasterList'
import BioMasterDetails from '../../slices/master/bio_master/BioMasterDetails'
import DiseaseMasterList from '../../slices/master/disease_master/DiseaseMasterList'
import DiseaseMasterDetails from '../../slices/master/disease_master/DiseaseMasterDetails'
import StageList from '../../slices/master/stage/StageList'
import StageDetails from '../../slices/master/stage/StageDetails'
import RequestTypeList from '../../slices/master/request_type/RequestTypeList'
import RequestTypeDetails from '../../slices/master/request_type/RequestTypeDetails'

const masterReducer = {
    countryList: CountryList,
    countryDetails: CountryDetails,
    stateList: StateList,
    stateDetails: StateDetails,
    statebyCountry: StatebyCountry,
    districtList: DistrictList,
    districtDetails: DistrictDetails,
    districtbyState: DistrictbyState,
    tehsilList: TehsilList,
    tehsilDetails: TehsilDetails,
    tehsilbyDistrict: TehsilbyDistrict,
    natureList: NatureList,
    natureDetails: NatureDetails,
    structureList: StructureList,
    structureDetails: StructureDetails,
    cropList: CropList,
    cropDetails: CropDetails,
    bioMasterList: BioMasterList,
    bioMasterDetails: BioMasterDetails,
    diseaseMasterList: DiseaseMasterList,
    diseaseMasterDetails: DiseaseMasterDetails,
    stageList: StageList,
    stageDetails: StageDetails,
    requestTypeList: RequestTypeList,
    requestTypeDetails: RequestTypeDetails,
};

export default masterReducer;